import { render, staticRenderFns } from "./AbonementBusinessCard.vue?vue&type=template&id=38e1dfe1&scoped=true&lang=pug&"
import script from "./AbonementBusinessCard.vue?vue&type=script&lang=js&"
export * from "./AbonementBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./AbonementBusinessCard.vue?vue&type=style&index=0&id=38e1dfe1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1dfe1",
  null
  
)

/* custom blocks */
import block0 from "./AbonementBusinessCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports